import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Container,
} from "reactstrap";
import React from "react";
import Loading from "../loader/loader.js";
import Select from "react-select";
import NkHeader from "../../common/nkheader.js";
import NkTable from "../users/nktable.js";

const Skucatalogpresentational = ({
  setSearchBy,
  itemloading,
  CategorySelect,
  categoryValue,
  searchBy,
  handleFilter,
  searchByValue,
  setShowFilterModal,
  resetFilter,
  noOfFiltersSelected,
  dataLoading,
  setfilterForm,
  filterForm,
  setSizeShow,
  columns,
  pagination,
  billerdetails,
  setSearchByValue,
  options,
  setCategoryValue,
}) => {
  return (
    <>
      <Container fluid>
        <NkHeader title="SKU Catalog" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="4" className="beneficiary-filter">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Search by
                  </label>

                  <Select
                    closeMenuOnSelect={true}
                    placeholder="Search Category"
                    onChange={(data) => {
                      setSearchBy(data);
                      if (data) {
                        CategorySelect(data.value);
                      } else {
                        setCategoryValue([]);
                      }
                    }}
                    options={options}
                    value={searchBy}
                  ></Select>
                </FormGroup>
              </Col>
              <Col lg="4" className="beneficiary-filter">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    Search for
                  </label>
                  {!itemloading ? (
                    <Select
                      closeMenuOnSelect={true}
                      placeholder="Search Value"
                      value={searchByValue}
                      onChange={(data) => {
                        setSearchByValue(data);
                      }}
                      options={categoryValue}
                    ></Select>
                  ) : (
                    <div
                      style={{
                        height: "4vh",
                        display: "flex",
                        placeContent: "center",
                      }}
                    >
                      <Loading color="white" width="15px" height="15px" />
                    </div>
                  )}
                </FormGroup>
              </Col>

              <div
                lg="1"
                className="form-input-padding"
                style={{ marginTop: "2px" }}
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Filter by
                  </Label>

                  <div>
                    <Button
                      style={{
                        width: "100%",
                        height: "26px",
                        marginTop: "4px",
                      }}
                      color="primary"
                      type="button"
                      id="example3cols2Input"
                      className="filter-button-beneficiery"
                      onClick={() => setShowFilterModal(true)}
                    >
                      <div>
                        <i className="fas fa-filter"></i>
                      </div>
                    </Button>
                  </div>
                </FormGroup>
                <span style={{ fontSize: 8 }}>
                  {noOfFiltersSelected > 0 ? (
                    <>
                      <h6 style={{ display: "flex", alignItems: "center" }}>
                        selected(
                        {noOfFiltersSelected}){" "}
                        <i
                          className="fas fa-window-close"
                          style={{ cursor: "pointer", paddingLeft: "5px" }}
                          onClick={() => resetFilter()}
                        />
                      </h6>
                    </>
                  ) : (
                    <></>
                  )}
                </span>
              </div>

              <Col lg="1" style={{ marginTop: "13px", padding: "0px 9px" }}>
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      id="example3cols2Input"
                      type="button"
                      style={{
                        width: "100%",
                        background: "#e91d24",
                        color: "white",
                        height: "26px",
                        border: "1px solid rgb(233, 29, 36)",
                      }}
                      className="filter-button"
                      onClick={() => handleFilter(true)}
                    >
                      <div>
                        <i className="fas fa-search" />
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
              <Col
                lg="1"
                style={{ marginTop: "13px", padding: "0px 6px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      color="light"
                      type="button"
                      style={{ width: "100%", height: "26px" }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => resetFilter()}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        <i className="fas fa-redo-alt 2px"></i> Reset
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row>
          <div className="col card-parent">
            <Card style={{ padding: "1.25rem 1.5rem" }}>
              {dataLoading ? (
                <div style={{ textAlign: "center" }}>
                  <Loading />
                </div>
              ) : (
                <>
                  <NkTable
                    data={billerdetails}
                    filterdata={filterForm}
                    columns={columns}
                    pagination={pagination}
                    onPagechange={(page) => {
                      setfilterForm({ ...filterForm, page: page });
                    }}
                    showSizeChanged={(pageSize) => {
                      setSizeShow(pageSize);
                      setfilterForm({ ...filterForm });
                    }}
                  />
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Skucatalogpresentational;
